import React, { Dispatch, SetStateAction, FC } from 'react'
import SALink from 'components/SALink'
import Follow from './Follow'
import Avatar from './Avatar'
import { displayEllipticalString, handleReadMoreClick } from '../../helpers'
import { capitalizeString } from 'lib/helpers'
import styles from './Header.module.scss'
import CaretDownIcon from 'svg/caret-down-v2.svg'
import EditIcon from 'svg/edit-v3.svg'
import classNames from 'classnames'
import useQA from 'hooks/useQA'
import { useSelector } from 'react-redux'
import { getPageParamSection, getAccountData, getAccountUserID, getBadges } from '../../selectors'
import { getUserID } from 'selectors/user/session'

type Props = {
  setFollowedUserArray: Dispatch<SetStateAction<ReadonlyArray<number>>>
  followedUserArray: ReadonlyArray<number>
  setTotalFollowers: Dispatch<SetStateAction<number>>
  totalFollowers: number
}

const MAX_LENGTH = 100

const Header: FC<Props> = ({
  followedUserArray,
  setFollowedUserArray,
  totalFollowers,
  setTotalFollowers,
}) => {
  const accountData = useSelector(getAccountData)
  const sessionUserID = useSelector(getUserID)
  const artistID = useSelector(getAccountUserID)
  const pageParamsSection = useSelector(getPageParamSection)
  const badges = useSelector(getBadges)
  const { avatar, firstName, lastName, aboutArtist, state, city, country, userId } = accountData
  const { about } = aboutArtist
  const myOwnAccount = sessionUserID === artistID
  const capitalizedName = capitalizeString(`${firstName} ${lastName}`)
  const { testId } = useQA()
  return (
    <div className={styles.header}>
      <div className={styles.artistInfoSection}>
        <Avatar avatar={avatar} userID={userId} />
        <div className={styles.artistInfo} {...testId('artist-info')}>
          <div className={styles.infoWrapper}>
            <div className={styles.nameCountrySection}>
              <h1 className={styles.name} {...testId('name')}>
                {capitalizedName}
              </h1>
              <p className={styles.country} {...testId('country')}>
                {city ? `${city},` : ''} {state ? `${state},` : ''} {country ? country : ''}
              </p>
            </div>
          </div>
          <div
            className={classNames(
              {
                [styles.aboutSectionMyOwnAccount]: myOwnAccount,
                [styles.aboutSectionNoLocation]: !city && !state && !country,
                [styles.aboutSectionNoAvatar]: !avatar,
              },
              styles.aboutSection
            )}
            {...testId('about-section-my-own-account')}
          >
            {about ? (
              <p className={styles.about}>{displayEllipticalString(about, MAX_LENGTH)}</p>
            ) : (
              ''
            )}
            {(about || badges.length) && !myOwnAccount ? (
              <button
                onClick={handleReadMoreClick}
                className={classNames(
                  {
                    [styles.readMoreSectionHide]: pageParamsSection === 'artworks',
                  },
                  styles.readMoreSection
                )}
              >
                <p className={styles.readMore}>Read More</p>
                <CaretDownIcon />
              </button>
            ) : (
              ''
            )}
          </div>
          {myOwnAccount && (
            <div
              {...testId('edit-links')}
              className={classNames(
                {
                  [styles.editLinksNoAbout]: !about,
                  [styles.editLinksNoAvatar]: !avatar,
                },
                styles.editLinks
              )}
            >
              <SALink className={styles.editProfileLink} href='/studio/profile-information'>
                <EditIcon />
                <p>Edit Profile</p>
              </SALink>
              <SALink className={styles.editProfileLink} href='/studio'>
                <p>Manage Artworks</p>
              </SALink>
            </div>
          )}
        </div>
      </div>
      <Follow
        showText={true}
        followedUserArray={followedUserArray}
        setFollowedUserArray={setFollowedUserArray}
        setTotalFollowers={setTotalFollowers}
        totalFollowers={totalFollowers}
      />
    </div>
  )
}

export default Header
